import { TabbedPage } from "../../components/TabbedPage";
import { InvoicesPage } from "../invoices/InvoicesPage";
import { AgingPage } from "../invoices/AgingPage";

/** Merged Invoices & Bills + Aging — both gated identically (ROLES_WITH_INVOICE_ACCESS),
 * so no per-tab role filtering is needed (the route guard in App.tsx covers both). */
export function InvoicesBillsPage() {
  return (
    <TabbedPage
      title="Invoices & Bills"
      defaultTab="invoices"
      tabs={[
        { key: "invoices", label: "Invoices & Bills", content: <InvoicesPage /> },
        { key: "aging", label: "Aging", content: <AgingPage /> },
      ]}
    />
  );
}
